import {
  billCreditOnHSIAOption,
  businessWifiOption,
  fibreOfferField,
  fieldAddProductVulcan,
  fieldNumberOfAccessPoints,
  internetBundleDiscountOption,
  internetDiscountFourtyFiveOption,
  internetDiscountOption,
  waivedInstallationFee
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

const FibreBusinessWifiHelpers = ({ formFields, fieldName, fields }) => {
  const addProductVulcanValue = getFieldValue(
    fieldAddProductVulcan,
    formFields
  );

  const fibreOfferFieldValue = getFieldValue(fibreOfferField, formFields);

  if (fieldName === fibreOfferField) {
    if (!formFields[fibreOfferField].value) {
      formFields[fibreOfferField].value = [
        internetBundleDiscountOption,
        waivedInstallationFee
      ];
    }

    disableOptions(
      formFields[fibreOfferField].options,
      [internetBundleDiscountOption, waivedInstallationFee],
      true
    );
    if (
      fibreOfferFieldValue &&
      fibreOfferFieldValue.includes(internetDiscountOption)
    ) {
      fields.options = formFields[fibreOfferField].options.filter(
        value => value.fields.value !== internetDiscountFourtyFiveOption
      );
    } else if (
      fibreOfferFieldValue &&
      fibreOfferFieldValue.includes(internetDiscountFourtyFiveOption)
    ) {
      fields.options = formFields[fibreOfferField].options.filter(
        value => value.fields.value !== internetDiscountOption
      );
    } else {
      fields.options = formFields[fibreOfferField].options;
    }
  }
  if (fieldName === fieldAddProductVulcan) {
    if (!addProductVulcanValue.includes(businessWifiOption)) {
      formFields[fieldNumberOfAccessPoints].value = undefined;
      formFields['selectTheDevice'].value = '';
    } else if (
      addProductVulcanValue.includes(businessWifiOption) &&
      !formFields[fieldNumberOfAccessPoints].value
    ) {
      formFields[fieldNumberOfAccessPoints].value = 1;
    }
  }
};

export default FibreBusinessWifiHelpers;
